import React from "react";
import {SearchForm} from "./searchForm"
import OrganTree from "./organTree"
import OrganForm from "./organForm"

const Organization = () => {
    return (
        <>
            <SearchForm/>
            <div className="flex">
                <OrganTree/>
                <OrganForm/>
            </div>
        </>
    )
}
export default Organization